import { GetterTree } from "vuex";
import { RootState } from "../types";
import { AnalyseState } from "./types";

export const getters: GetterTree<AnalyseState, RootState> = {};
